const ENDPOINT_PATH = "https://auth.x-orsystem.com/api/public/"
const VERSION = "v1"
export default {
  api() { return { endpoint: ENDPOINT_PATH, version: VERSION } },
};
